import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Stepper,
  Step,
  StepLabel
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { register } from "../../../../core/redux/action/auth";

import PersonalInformation1 from "./Forms/PersonalInformation1";
import PersonalInformation2 from "./Forms/PersonalInformation2";
import EducationBackground from "./Forms/EducationBackground";
import WorkingExperience from "./Forms/WorkingExperience";

import RegisterSuccess from "./RegisterSuccess";

import validationSchema from "./FormModel/validationSchema";
import postDocFormModel from "./FormModel/postDocFormModel";
import formInitialValues from "./FormModel/formInitialValues";

import useStyles from "./styles";

const steps = [
  "Personal Information",
  "Postdoctoral Information",
  "Education Background",
  "Working Experience"
];
const { formId, formField } = postDocFormModel;

function _renderStepContent(step) {
  switch (step) {
    case 0:
      return <PersonalInformation1 formField={formField} />;
    case 1:
      return <PersonalInformation2 formField={formField} />;
    case 2:
      return <EducationBackground formField={formField} />;
    case 3:
      return <WorkingExperience formField={formField} />;
    default:
      return <>Not Found</>;
  }
}

export default function RegisterPostDocPage() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    var formData = new FormData();

    for (const [key, value] of Object.entries(values)) {
      if (value?.file) {
        formData.append(key, value.file);
      } else {
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value ? value : "");
        }
      }
    }
    //post_doc
    formData.append("role", 1);

    dispatch(register(formData));

    await _sleep(1000);
    actions.setSubmitting(false);
    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  return (
    <Container>
      <Box sx={{ textAlign: "center" }}>
        <>
          <Typography component="h1" variant="h4" align="center">
            Registration for C2F Postdoc
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <RegisterSuccess />
          ) : (
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              {({ isSubmitting }) => {
                return (
                  <Form id={formId}>
                    {_renderStepContent(activeStep)}

                    <Box className={classes.buttons}>
                      {activeStep !== 0 && (
                        <Button
                          onClick={_handleBack}
                          className={classes.button}
                        >
                          Back
                        </Button>
                      )}
                      <Box className={classes.wrapper}>
                        <LoadingButton
                          loading={isSubmitting}
                          disabled={isSubmitting}
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={classes.button}
                        >
                          {isLastStep ? "Submit" : "Next"}
                        </LoadingButton>
                      </Box>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          )}
        </>
      </Box>
    </Container>
  );
}
